<template>
  <q-dialog
    :model-value="modelValue"
    persistent
    @update:model-value="emit('update:modelValue', $event)"
  >
    <q-card style="width: 600px; max-width: 80vw;">
      <q-card-section>
        <div class="text-h6">Add Internal Zone Section to {{ selectedAhu?.name }}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <div class="text-caption text-grey-7 q-mb-md">
          Zone sections are internal mechanical divisions within the AHU that contain dampers to control airflow to different building areas
        </div>

        <!-- Zone Template Selection -->
        <q-select
          v-if="zoneTemplates.length > 0"
          :model-value="selectedZoneTemplate"
          :options="zoneTemplates"
          label="Use Template (Optional)"
          option-label="name"
          option-value="id"
          clearable
          outlined
          dense
          class="q-mb-md"
          @update:model-value="emit('apply-zone-template', $event)"
        >
          <template #prepend>
            <q-icon name="inventory_2" />
          </template>
          <template #option="scope">
            <q-item v-bind="scope.itemProps">
              <q-item-section>
                <q-item-label>{{ scope.opt.name }}</q-item-label>
                <q-item-label caption>{{ scope.opt.description }}</q-item-label>
              </q-item-section>
            </q-item>
          </template>
        </q-select>

        <q-input
          :model-value="formData.name"
          label="Zone Section Name"
          hint="e.g., Zone 1, North Zone, East Wing Zone"
          filled
          class="q-mb-md"
          @update:model-value="emit('update:name', $event)"
        />

        <q-select
          :model-value="formData.zone_type"
          :options="zoneSectionTypeOptions"
          label="Zone Type"
          hint="Type of zone control"
          filled
          emit-value
          map-options
          class="q-mb-md"
          @update:model-value="emit('update:zone-type', $event)"
        />

        <q-select
          :model-value="formData.serves_space"
          :options="availableSpacesForZone"
          label="Building Area Served (Optional)"
          hint="Which building space this zone section feeds"
          filled
          clearable
          emit-value
          map-options
          option-label="label"
          option-value="value"
          @update:model-value="emit('update:serves-space', $event)"
        />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn v-close-popup flat label="Cancel" @click="emit('reset')" />
        <q-btn
          color="primary"
          label="Add Zone Section"
          :disable="!formData.name"
          @click="emit('submit')"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      required: true,
    },
    selectedAhu: {
      type: Object,
      default: null,
    },
    zoneTemplates: {
      type: Array,
      default: () => [],
    },
    selectedZoneTemplate: {
      type: Object,
      default: null,
    },
    zoneSectionTypeOptions: {
      type: Array,
      default: () => [],
    },
    availableSpacesForZone: {
      type: Array,
      default: () => [],
    },
  });

  const emit = defineEmits([
    'update:modelValue',
    'update:name',
    'update:zone-type',
    'update:serves-space',
    'apply-zone-template',
    'reset',
    'submit',
  ]);
</script>
